import React from 'react';
import { TCallToAction } from '../../../store/callToAction/types';

export const useCloseInfoWindow = (callToAction: TCallToAction | null, type: number) => {
  const [isClose, setIsClose] = React.useState(true);

  React.useEffect(() => {
    const id = sessionStorage.getItem('callToActionId');
    if (callToAction && callToAction.typeBtn === type) {
      if (Number(id) !== callToAction.id || !id) {
        setIsClose(false);
      }
    }
  }, [callToAction, type]);

  const closeWindow = (id: number) => {
    sessionStorage.setItem('callToActionId', String(id));
    setIsClose(true);
  };

  return {
    isClose,
    closeWindow,
  };
};
